import React from 'react';
import { Box, Typography, Tabs, Tab, Button, Paper } from '@mui/material';
import MainMenuDrawer from '../../components/Main/MenuDrawer';
import Header from '../../components/common/Header';
import { useNavigate } from 'react-router-dom';
import { getServiceLinksApi } from '../../api';

const EtravelPickdropPage = () => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [tab, setTab] = React.useState(0);
  const [serviceLinks, setServiceLinks] = React.useState({
    telegram: '',
    kakao: '',
  });
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const commonStyles = {
    title: {
      fontWeight: 700,
      textAlign: 'center',
      mb: 1,
      fontSize: 22,
    },
    description: {
      textAlign: 'center',
      color: '#535353',
      fontSize: 15,
      fontWeight: 500,
      mb: 0.5,
    },
    applyButton: {
      color: '#ffffff',
      fontWeight: 600,
      fontSize: 13,
      py: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
    },
  };

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getServiceLinksApi();
        const items = res?.data || [];
        const next = { telegram: '', kakao: '' };
        for (const it of items) {
          if (it?.key === 'telegram' && it?.url) next.telegram = it.url;
          if (it?.key === 'kakao' && it?.url) next.kakao = it.url;
        }
        if (alive) setServiceLinks(next);
      } catch {
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const openExternal = (url) => {
    const u = String(url || '').trim();
    if (!u) return;
    window.open(u, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box>
      <Box
        sx={{
          maxWidth: 430,
          mx: 'auto',
          bgcolor: 'white',
          minHeight: '100vh',
          borderRadius: 0,
          boxShadow: '0 0 20px rgba(0,0,0,0.06)',
          px: 2,
          position: 'relative',
        }}
      >
        <MainMenuDrawer
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          onNavigate={handleNavigate}
        />

        <Header
          variant="full"
          onClickMenu={() => setMenuOpen(true)}
        />

        <Box sx={{ mb: 4, mt: 1.5 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, mb: 2, fontSize: 22 }}
          >
            E-TRAVEL/픽드랍
          </Typography>

          <Box
            sx={{
              width: 380,
              maxWidth: '100%',
              height: 45,
              borderRadius: 1.5,
              border: '1px solid #e0e0e0',
              overflow: 'hidden',
              mx: 'auto',
            }}
          >
            <Tabs
              value={tab}
              onChange={(_e, value) => setTab(value)}
              variant="fullWidth"
              textColor="inherit"
              sx={{
                minHeight: 45,
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiTab-root': {
                  minHeight: 45,
                  fontSize: 13,
                  fontWeight: 500,
                  px: 0,
                  bgcolor: '#f9f9f9',
                  lineHeight: 1,
                },
                '& .MuiTab-root:first-of-type': {
                  borderRight: '1px solid #e0e0e0',
                },
                '& .MuiTab-root.Mui-selected': {
                  fontWeight: 700,
                  bgcolor: '#ffffff',
                },
              }}
            >
              <Tab label="E-TRAVEL" disableRipple />
              <Tab label="픽업/드랍" disableRipple />
            </Tabs>
          </Box>

          {tab === 0 && (
            <>
              <Button
                variant="outlined"
                sx={{
                  mt: 2,
                  width: 380,
                  height: 55,
                  maxWidth: '100%',
                  mx: 'auto',
                  display: 'block',
                  borderRadius: 1.5,
                  borderColor: '#c9e0ff',
                  bgcolor: '#f4f8ff',
                  color: '#0d47a1',
                  fontWeight: 600,
                  fontSize: 14,
                }}
                onClick={() => openExternal('https://etravel.gov.ph/kr')}
              >
                공식 사이트에서 직접 등록하기
              </Button>

              <Paper
                elevation={0}
                sx={{
                  mt: 3,
                  px: 3,
                  pt: 1,
                  pb: 3,
                  width: 380,
                  height: 348,
                  maxWidth: '100%',
                  mx: 'auto',
                  borderRadius: 2,
                  border: '1px solid #eee',
                  bgcolor: '#ffffff',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
              <Typography
                variant="subtitle1"
                sx={commonStyles.title}
              >
                E-TRAVEL QR 등록 대행
              </Typography>
              <Typography
                variant="body2"
                sx={commonStyles.description}
              >
                필리핀 입국을 위한
              </Typography>
              <Typography
                variant="body2"
                sx={commonStyles.description}
              >
                E-TRAVEL QR 발급을 도와드립니다.
              </Typography>
              <Typography
                variant="body2"
                sx={{ ...commonStyles.description, mb: 2 }}
              >
                필요한 자료를 업로드 해주세요.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  gap: 1.5,
                  mb: 3,
                  width: 380,
                  maxWidth: '100%',
                  mx: 'auto',
                  justifyContent: 'space-between',
                }}
              >
                {[
                  '여권사진',
                  '항공권\n(오는편)',
                  '항공권\n(가는편)',
                ].map((label) => (
                  <Paper
                    key={label}
                    elevation={0}
                    sx={{
                      width: 106,
                      height: 100,
                      borderRadius: '10px',
                      border: '1px solid #D8D8D8',
                      bgcolor: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      py: 2.5,
                      px: 1,
                      boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 700, fontSize: 15 }}
                    >
                      {label}
                    </Typography>
                  </Paper>
                ))}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  gap: 1.5,
                  width: 380,
                  maxWidth: '100%',
                  mx: 'auto',
                  mt: 'auto',
                }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    ...commonStyles.applyButton,
                    bgcolor: '#007BDB',
                    '&:hover': { bgcolor: '#0065b4' },
                  }}
                  onClick={() => openExternal(serviceLinks.telegram)}
                >
                  <Box
                    component="img"
                    src="/logo/tel__logo.png"
                    alt="텔레그램 로고"
                    sx={{ width: 24, height: 24 }}
                  />
                  텔레그램 신청
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    ...commonStyles.applyButton,
                    bgcolor: '#ffcc00',
                    '&:hover': { bgcolor: '#f5c200' },
                  }}
                  onClick={() => openExternal(serviceLinks.kakao)}
                >
                  <Box
                    component="img"
                    src="/logo/kakao_logo.png"
                    alt="카카오톡 로고"
                    sx={{ width: 24, height: 24 }}
                  />
                  카카오톡 신청
                </Button>
              </Box>
            </Paper>
            </>
          )}

          {tab === 1 && (
            <Paper
              elevation={0}
              sx={{
                mt: 3,
                px: 3,
                pt: 1,
                pb: 3,
                width: 380,
                maxWidth: '100%',
                mx: 'auto',
                minHeight: 348,
                borderRadius: 2,
                border: '1px solid #eee',
                bgcolor: '#ffffff',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                variant="subtitle1"
                sx={commonStyles.title}
              >
                공항 픽드랍 신청
              </Typography>
              <Typography
                variant="body2"
                sx={{ ...commonStyles.description, mb: 2 }}
              >
                차량 샌딩을 요청하세요
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  justifyContent: 'center',
                  mb: 2.5,
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src="/icon/hotel_icon.png"
                    alt="호텔 아이콘"
                    sx={{ width: 68, height: 68, objectFit: 'contain' }}
                  />
                </Paper>

                <Box>
                  <Typography
                    variant="body2"
                    sx={{ color: '#000000', mb: 0.5, fontWeight: 600 }}
                  >
                    도착지는 공항 ➝ 호텔,
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: '#000000', fontWeight: 600 }}
                  >
                    호텔 ➝ 공항만 가능합니다.
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  gap: 1.5,
                  mb: 2.5,
                }}
              >
                {[
                  { name: 'Okada', label: '호텔', image: '/image/hotel1_image.png' },
                  { name: 'Solaire', label: '호텔', image: '/image/hotel2_image.png' },
                  { name: 'C.O.D', label: '호텔', image: '/image/hotel3_image.png' },
                ].map((hotel) => (
                  <Paper
                    key={hotel.name}
                    elevation={0}
                    sx={{
                      width: 106,
                      height: 149,
                      borderRadius: 2,
                      border: '1px solid #e5e5e5',
                      overflow: 'hidden',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                      bgcolor: '#ffffff',
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: 82,
                        width: '100%',
                        objectFit: 'cover',
                      }}
                      src={hotel.image}
                      alt={`${hotel.name} 이미지`}
                    />
                    <Box
                      sx={{
                        py: 1.2,
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 700, fontSize: 12 }}
                      >
                        {hotel.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ fontSize: 11, color: 'text.secondary' }}
                      >
                        {hotel.label}
                      </Typography>
                    </Box>
                  </Paper>
                ))}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  gap: 1.5,
                  width: 380,
                  maxWidth: '100%',
                  mx: 'auto',
                  mt: 'auto',
                }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    ...commonStyles.applyButton,
                    bgcolor: '#007BDB',
                    '&:hover': { bgcolor: '#0065b4' },
                  }}
                  onClick={() => openExternal(serviceLinks.telegram)}
                >
                  <Box
                    component="img"
                    src="/logo/tel__logo.png"
                    alt="텔레그램 로고"
                    sx={{ width: 24, height: 24 }}
                  />
                  텔레그램 신청
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    ...commonStyles.applyButton,
                    bgcolor: '#ffcc00',
                    '&:hover': { bgcolor: '#f5c200' },
                  }}
                  onClick={() => openExternal(serviceLinks.kakao)}
                >
                  <Box
                    component="img"
                    src="/logo/kakao_logo.png"
                    alt="카카오톡 로고"
                    sx={{ width: 24, height: 24 }}
                  />
                  카카오톡 신청
                </Button>
              </Box>
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EtravelPickdropPage;

